import clsx from "classnames";
import classes from "./styles.module.scss";
import { Button, Container, Stack } from "react-bootstrap";
import { Title } from "@/ui";

export default function AnchorToComponents({ className, showTitle, title, titleColor, bgColor, items }) {
  return (
    <div className={clsx(className, bgColor, classes.TrendingButtons)}>
      <Container className="mw-xl text-center">
        {showTitle && <h3 className={clsx(titleColor, "mb-3")}>{title}</h3>}

        <Stack className="flex-row flex-wrap justify-content-center" gap={2}>
          {items.map((i, idx) => (
            <Button key={idx} className="mb-1 px-3" variant={i.variant} href={i.href}>
              {i.label}
            </Button>
          ))}
        </Stack>
      </Container>
    </div>
  );
}
